import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/CalendarSelectDrawer';
import { CalendarSelectSheet } from '@/domain/termine/features/CreateTermin/Sheet/components/CalendarSelectSheet';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

export function CalendarSelectFormField() {
  const { isMobile } = useCreateTermineFormContext();
  const { kalender } = useCalendarContext();

  const hasKalender = kalender?.some((k) => k.id !== 'NO_KALENDER');

  if (!hasKalender) {
    return null;
  }

  return (
    <>
      {isMobile ? (
        <CalendarSelectDrawer kalender={kalender} />
      ) : (
        <CalendarSelectSheet kalender={kalender} />
      )}
    </>
  );
}
